import { render, staticRenderFns } from "./ProjectNavigation.vue?vue&type=template&id=b25779a0&"
import script from "./ProjectNavigation.vue?vue&type=script&lang=js&"
export * from "./ProjectNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports